import { Observable } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RequestService } from '../../lib/services';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private _requestService: RequestService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers;
    if (req.url.includes('media/images')) {
      headers = this._requestService.getHeaders(true);
    } else {
      headers = this._requestService.getHeaders();
    }
    if (environment.local) {
      const apiReq = req.clone({ headers: headers });
      return next.handle(apiReq);
    } else {
      const newUrl = req.url.replace(/^http:\/\//i, 'https://');
      const apiReq = req.clone({ headers: headers, url: `${newUrl}` });
      return next.handle(apiReq);
    }
  }
}
